
import React, { useState } from 'react';
import PageBox from '../../components/PageBox';
import ProTitle from '../../components/ProTitle';
import { Anchor } from 'antd';
import Last from './last';
import './index.less'
import proicon from "../../static/images/proicon.png"
import tb1 from "../../static/images/tb1.png"
import tb2 from "../../static/images/tb2.png"
import tb3 from "../../static/images/tb3.png"
import tb4 from "../../static/images/tb4.png"
export default function App() {
  const memo = '深度挖掘风险项，并结合相关法律法规，向尽调人员直观揭示尽调的不合规项，快速生成初步尽调底稿，可全面了解企业信用评价、基本信息、经营分析、财务分析、融资能力、资产信息、经营风险、对外投资、背景分析与关联风险等内容'
  const memob ='招标文件生成与质检模块是招采业务中的核心工具，聚焦 “高效生成” 与 “合规保障” 两大核心目标，通过智能化技术覆盖招标文件从初稿到终稿的全流程，既解决人工编写效率低、易出错的问题，又杜绝因文件不合规导致的项目风险'
  const memoc='投标文件交叉比对模块是招采过程中防范围标串标、保障公平竞争的核心工具，通过对多份投标文件的文本内容、数据信息、技术方案等维度进行智能比对分析，自动识别异常关联特征，解决人工比对效率低、易遗漏的痛点，为评标委员会提供客观、精准的异常线索支撑'
  const memod="合同生成与比对模块是招采流程中衔接评标定标与履约管理的关键工具，聚焦 “高效生成合规合同” 与 “精准校验条款一致性” 两大目标，通过智能化技术减少人工操作误差，确保合同内容与招标要求、投标承诺高度匹配，从源头规避履约阶段的条款争议与法律风险"
  const item =[
    {title:'招标文件生成与质检', key:'part-1', href:'#part-1',},
    {title:'投标文件交叉比对', key:'part-2', href:'#part-2', },
    {title:'合同生成与比对', key:'part-3', href:'#part-3',},
    {title:'价格趋势与指数', key:'part-5', href:'#part-5',},
    {title:'市场调研与分析', key:'part-6', href:'#part-6',},
    {title:'投标供应商基础信息与关联关系查询（参考）', key:'part-4', href:'#part-4',},
  ]
  const [top, setTop] = useState(70);
  return (
    <>
      <PageBox useBanner={true}>
        <div className='aimodelBanner'></div>
        <ProTitle name={'垂类智能模型'} memo={memo} />
        <div className='aimodel'>
            <Anchor offsetTop={top} direction="horizontal" items={item} />
        </div>
        <div>
        <div>
        <div className='zhijian' id="part-1">
          <ProTitle name={'招标文件生成与质检'} memo={memob} />
          <div className='content'>
            <div className='content-right'>
              <ul>
                <li>
                  <h3>模板化智能生成</h3>
                  <div>内置符合国家及行业规范的招采模板库（涵盖工程、货物、服务等类别），用户输入项目基础信息后，系统可自动填充关键内容并生成招标文件初稿，大幅减少基础文案编写工作</div>
                </li>
                <li>
                  <h3>多维度合规质检</h3>
                  <div>基于招采行业法规库，自动扫描招标文件中的不合规内容，并标注违规依据与修改建议，避免因文件不合规导致的项目流标或法律风险</div>
                </li>
                <li>
                  <h3>协同编辑与版本管理</h3>
                  <div>支持多人在线协同编写招标文件，不同角色可实时批注修改内容，系统自动记录每一次编辑痕迹；同时留存所有版本记录，可一键回溯历史版本，解决多人协作时的内容冲突与版本混乱问题</div>
                </li>
                <li>
                  <h3>关键信息校验与补全</h3>
                  <div>自动校验招标文件中的关键信息完整性，若存在缺失或错误，系统会实时弹窗提醒并引导补全，确保文件核心信息无遗漏、无差错</div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div id="part-2">
          <ProTitle name={'投标文件交叉比对'} memo={memoc} />
          <div className="toubiao">
            <ul>
              <li>
                <div><img src={tb2} /></div>
                <h3>关键数据关联分析</h3>
                <p>针对投标文件中的报价明细、人员配置、设备参数等核心数据，建立多维度比对模型，可自动识别不同投标文件间的异常数据关联（如报价构成比例高度一致、拟派项目团队人员信息重复），并生成数据关联热力图，直观呈现异常关联程度</p>
              </li>
              <li>
                <div><img src={tb1} /></div>
                <h3>文本相似度智能比对</h3>
                <p>自动提取各投标文件中的技术方案、实施方案、售后服务承诺等文本内容，通过 NLP 算法计算文本相似度，识别高度雷同的表述片段并标记位置，快速发现 “抄袭式” 投标痕迹，辅助判断是否存在串标嫌疑</p>
              </li>
              <li>
                <div><img src={tb4} /></div>
                <h3>格式与标识一致性校验</h3>
                <p>校验多份投标文件的文档格式（如字体、行距、页码样式）、隐藏元数据（如文件创建者、修改时间）、特定标识（如页眉页脚 logo、落款格式）是否存在非巧合的一致性，捕捉 “同一机构代编” 的潜在线索，填补人工审查的盲区</p>
              </li>
              <li>
                <div><img src={tb3} /></div>
                <h3>比对结果可视化输出</h3>
                <p>将交叉比对的异常点（相似文本片段、关联数据、格式一致性问题）整理成结构化报告，通过高亮标注、差异对比表格、关联关系图谱等形式直观呈现；帮助评标人员快速聚焦关键疑点，提升评审效率与准确性</p>
              </li>
            </ul>
          </div>
        </div>
        <div className="hetong" id="part-3">
          <ProTitle name={'合同生成与比对'} memo={memod} />
            <div className='hetong-con'>
              <ul>
                <li>
                  <p>自动根据模版，按照采购标的、数量、价格、履约期限、付款方式生成合同，无需人工重复录入即可生成符合行业规范的合同初稿；模板条款同步最新法律法规，保障合同基础框架合规</p>
                  <h3>招采数据联动生成合同</h3>
                </li>
                <li className="list">
                  <p>内置多品类合同模板库，模板条款符合《民法典》《政府采购法》等最新法规；系统可根据项目类型自动匹配对应模板，并预加载行业通用约定（如质保期、验收标准），减少模板筛选与调整时间</p>
                  <h3>行业化模板智能适配</h3>
                </li>
                <li>
                  <p>支持合同文件不同版本交叉比对，自动识别差异点（如合同价格与中标金额不一致、履约时间与投标承诺冲突），用不同颜色高亮标注差异位置，并生成差异对照表，清晰呈现需修正内容</p>
                  <h3>多维度跨文件比对校验</h3>
                </li>
                <li>
                  <p>基于法规库，自动扫描合同中的不合规条款（如免除自身法定责任、约定模糊的争议解决方式、违背公平原则的违约责任），同步弹出违规依据（如具体法条）与修改建议，降低合同因不合规被认定无效的风险</p>
                  <h3>条款合规智能质检</h3>
                </li>
                <li className="list">
                  <p>自动留存合同修改的所有版本，记录每一次编辑的人员、时间与内容变更；支持一键回溯任意历史版本，对比不同版本间的条款差异，解决多人协作时 “改哪了、谁改的” 的追溯难题</p>
                  <h3>版本管理与痕迹追溯</h3>
                </li>
                <li>
                  <p>在线电子签章模块是合同数字化签署的核心工具，通过符合国家《电子签名法》的加密技术，既保障签章的合法性与安全性，又大幅缩短签署周期，助力招采流程全链路数字化闭环</p>
                  <h3>在线电子签章</h3>
                </li>
              </ul>
            </div>
        </div>
        <Last />
        </div>
      </div>
      </PageBox>
    </>
    
  );
}
